module.exports = __webpack_public_path__ + "static/img/logo11.955a8e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/link2/logo11.jpg
// module id = B+Gc
// module chunks = 1